import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string().url().default('http://localhost:8000'),
  VITE_WS_URL: z.string().default('ws://localhost:8000'),
  VITE_CARTO_TILE_URL: z
    .string()
    .default('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'),
  VITE_SENTRY_DSN: z.string().optional(),
});

export const env = envSchema.parse({
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_WS_URL: import.meta.env.VITE_WS_URL,
  VITE_CARTO_TILE_URL: import.meta.env.VITE_CARTO_TILE_URL,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
});
